import { KTCard } from '@/_metronic/helpers/components/KTCard'
import { FC, useState } from 'react'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import Overview from './Overview'
import { FilterReportRevenueSharingModal } from './components/filter/FilterReportRevenueSharingModal'
import { ReportRevenueSharingListHeader } from './components/filter/ReportRevenueSharingListHeader'
import {
  FilterReportRevenueSharingProvider,
  useFilterReportRevenueSharing,
} from './core/FilterReportRevenueSharingProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { QueryResponseMonthlyProvider } from '../dashboard-forecast/core/QueryResponseMonthlyProvider'
import { QueryResponseNewOutletProvider } from './core/QueryResponseActualNewOutletProvider'
import { QueryResponseActualTargetProvider } from './core/QueryResponseActualTargetProvider'

const RevenuePeformancePage = () => {
  const [activeTab, setActiveTab] = useState<string>('overview')
  const { closeModal, showFilterReportRevenueSharingModal } = useFilterReportRevenueSharing()

  return (
    <>
      <PageTitle breadcrumbs={[]}>Dashboard Revenue Performance</PageTitle>

      <KTCard className='py-4 shadow-wit-2 mb-10'>
        <ReportRevenueSharingListHeader />
      </KTCard>

      <Overview />
      <FilterReportRevenueSharingModal
        show={showFilterReportRevenueSharingModal}
        closeModal={() => closeModal()}
      />
    </>
  )
}

const RevenuePerformanceWrapper: FC = () => {
  return (
    <>
      <QueryRequestProvider>
        {/* <QueryResponseProvider> */}
        <QueryResponseMonthlyProvider>
          <QueryResponseNewOutletProvider>
            <QueryResponseActualTargetProvider>
              <FilterReportRevenueSharingProvider>
                <RevenuePeformancePage />
              </FilterReportRevenueSharingProvider>
            </QueryResponseActualTargetProvider>
          </QueryResponseNewOutletProvider>
        </QueryResponseMonthlyProvider>
        {/* </QueryResponseProvider> */}
      </QueryRequestProvider >
    </>
  )
}

export { RevenuePerformanceWrapper }
